import { createContext } from 'react';

const DeliveryIdContext = createContext();

export default DeliveryIdContext;
